export const AUTH_FAILED = 'AUTH_FAILED';
export const MISSING_AUTH_PARAMS = 'MISSING_AUTH_PARAMS';
export const AUTH_REQUIRED = 'AUTH_REQUIRED';
export const FAILED_TO_CALL_GAME_ENGINE = 'FAILED_TO_CALL_GAME_ENGINE';
export const PLAYER_BLOCKED = 'PLAYER_BLOCKED';
export const GAME_NOT_SUPPORTED_FOR_DEVICE = 'GAME_NOT_SUPPORTED_FOR_DEVICE';
export const TABLE_IS_CLOSED = 'TABLE_IS_CLOSED';
export const TABLE_OCCUPIED = 'TABLE_OCCUPIED';
export const INSUFFICIENT_FUNDS_FOR_ENTRY = 'INSUFFICIENT_FUNDS_FOR_ENTRY';
export const DENIED_CAMERA_ACCESS = 'DENIED_CAMERA_ACCESS';
export const DENIED_MICROPHONE_ACCESS = 'DENIED_MICROPHONE_ACCESS';
export const AGORA_ERROR = 'AGORA_ERROR';
export const AGORA_CONFIG_MISSING_ERROR = 'AGORA_CONFIG_MISSING_ERROR';
export const VIDEO_MODERATION_KICK = 'VIDEO_MODERATION_KICK';
export const VIDEO_MODERATION_BAN = 'VIDEO_MODERATION_BAN';
export const GAME_LOAD_FAILURE = 'GAME_LOAD_FAILURE';
export const BAD_INTERNET_CONNECTION = 'BAD_INTERNET_CONNECTION';
export const MISSING_AUTH_PARAMS_OPERATOR_ID = 'MISSING_AUTH_PARAMS_OPERATOR_ID';
export const MISSING_AUTH_PARAMS_TOKEN = 'MISSING_AUTH_PARAMS_TOKEN';
export const MISSING_AUTH_PARAMS_UID = 'MISSING_AUTH_PARAMS_UID';
export const MISSING_AUTH_PARAMS_NICKNAME = 'MISSING_AUTH_PARAMS_NICKNAME';
export const LIMIT_REACHED = 'LIMIT_REACHED';
export const CURRENCY_MISMATCH = 'CURRENCY_MISMATCH';

export const CODES = {
  [AUTH_FAILED]: 2026,
  [AUTH_REQUIRED]: 2022,
  [MISSING_AUTH_PARAMS_OPERATOR_ID]: 2008,
  [MISSING_AUTH_PARAMS_TOKEN]: 2009,
  [MISSING_AUTH_PARAMS_UID]: 2028,
  [MISSING_AUTH_PARAMS_NICKNAME]: 2029,
  [MISSING_AUTH_PARAMS]: 2031,
  [FAILED_TO_CALL_GAME_ENGINE]: 104,
  [PLAYER_BLOCKED]: 106,
  [GAME_NOT_SUPPORTED_FOR_DEVICE]: 202,
  [TABLE_IS_CLOSED]: 203,
  [TABLE_OCCUPIED]: 211,
  [INSUFFICIENT_FUNDS_FOR_ENTRY]: 212,
  [DENIED_CAMERA_ACCESS]: 311,
  [DENIED_MICROPHONE_ACCESS]: 312,
  [AGORA_ERROR]: 313,
  [VIDEO_MODERATION_KICK]: 314,
  [VIDEO_MODERATION_BAN]: 315,
  [LIMIT_REACHED]: 316,
  [GAME_LOAD_FAILURE]: 3001,
  [BAD_INTERNET_CONNECTION]: 208,
  [CURRENCY_MISMATCH]: 30088,
};

export const missingAuthParamsErrorCodes = Object.entries(CODES)
  .filter(([ name, _code ]) => name.startsWith('MISSING_AUTH_PARAMS')).map(([ _name, code ]) => code);
